/**
 * Test ID utilities for Progress component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for progress elements
 * @param identifier - Progress identifier (e.g., 'upload', 'loading')
 * @returns Test ID string
 */
export const setProgressTestId = (identifier: string): string => generateTestId("Progress", identifier.replace(/\s+/g, "-").toLowerCase());
